import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button as SemanticButton } from 'semantic-ui-react'
import classnames from 'classnames/bind'
import styles from './styles.scss'
const cx = classnames.bind(styles)

class Button extends Component {
  static propTypes = {
    ...SemanticButton.propTypes,
    role: PropTypes.oneOf([
      'primary',
      'secondary',
      'tertiary',
      'default', // TO BE DEPRECATED
      'brand', // TO BE DEPRECATED
      'navigation', // TO BE DEPRECATED
      'navigation-light', // TO BE DEPRECATED
    ]),
    color: PropTypes.oneOf([
      'info',
      'success',
      'adcLightGreen60', // TODO: deal with this
      'caution',
      'error',
      'gray',
      'purple',
      undefined,
    ]),
    size: PropTypes.oneOf(['small', 'medium', 'large', 'marshmallow']),
    tag: PropTypes.oneOf(['button', 'div', 'a']),
    isStretch: PropTypes.bool,
    isSelected: PropTypes.bool,
    collapse: PropTypes.bool,
    link: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.node,
    elmId: PropTypes.string,
  }

  static defaultProps = {
    ...SemanticButton.defaultProps,
    role: null,
    color: null,
    size: 'medium',
    tag: 'button',
    isStretch: false,
    isSelected: false,
    collapse: false,
    link: null,
    className: null,
    children: null,
    elmId: null,
  }

  static Group = SemanticButton.Group

  render() {
    const {
      role,
      color,
      size,
      tag,
      isStretch,
      isSelected,
      collapse,
      link,
      className,
      children,
      elmId,
      ...rest
    } = this.props

    let newRole = role
    let newColor = color

    /**
     * Some backwards compatibility for old role usage:
     * - undefined: renders as secondary/gray
     * - default: renders as secondary/gray
     * - primary: renders as info/blue (by default)
     * - secondary: renders as info/blue (by default)
     */
    if (!newRole) {
      newRole = 'secondary'
      newColor = newColor || 'gray'
    } else if (newRole === 'default') {
      // NOTE: default role is deprecated
      newRole = 'secondary' // the old default role is now secondary
      newColor = 'gray'
    } else if (newRole !== 'default' && !newColor) {
      newColor = 'info'
    }

    if (newColor === 'basic') newColor = 'gray'

    const baseClasses = [
      'button-root',
      `button-role-${newRole}`,
      `button-color-${newColor}`,
      `button-is-${size}`,
    ]

    if (isStretch) baseClasses.push('button-is-stretch')
    if (isSelected) baseClasses.push('button-is-selected')
    const tagName = link ? 'a' : tag || 'button'

    const newClassName = cx(
      ...baseClasses.map(cls => styles[cls]),
      { collapse },
      className
    )

    return (
      <SemanticButton
        {...rest} // rest comes first, so we overwrite any default props with ours
        className={newClassName}
        as={tagName}
        href={link}
        data-elm-id={elmId}
      >
        {children}
      </SemanticButton>
    )
  }
}

Button.Group = ({ wrap, ...props }) =>
  SemanticButton.Group({
    className: cx('button-group', { wrap }),
    ...props,
    basic: true,
  })
export default Button
